export type SourceType =
  | 'web_search_citations'
  | 'refutation_finder'
  | 'search_agent'
  | 'agentful_web_search_citations';

/**
 * Get the display name for a citation source type
 */
export const getSourceDisplayName = (source: SourceType | string): string => {
  switch (source) {
    case 'web_search_citations':
      return 'Web Search';
    case 'refutation_finder':
      return 'Academia Search';
    case 'search_agent':
      return 'Search Agent';
    case 'agentful_web_search_citations':
      return 'Agentic Web Search';
    default:
      return 'Unknown Source';
  }
};
